import React from 'react';
type Props = {
  children: React.ReactNode;
  id?: string;
  className?: string;
  containerClassName?: string;
};
export function Section({
  children,
  id,
  className = '',
  containerClassName = ''
}: Props) {
  return <section id={id} className={`w-full px-4 py-10 sm:px-6 sm:py-16 ${className}`} data-id="element-303" data-mp="2vxsyam84nlfi">
      <div className={`mx-auto w-full max-w-6xl ${containerClassName}`} data-id="element-304" data-mp="2r5stafd7a2c2">{children}</div>
    </section>;
}
export function Eyebrow({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <span className={`inline-block text-[10px] font-semibold uppercase tracking-luxe text-rosegold sm:text-xs ${className}`} data-id="element-305" data-mp="30v2ow579634x">
      {children}
    </span>;
}